import Vue from 'vue';
import AttensiLogin, { AttensiLoginOptions } from '@attensi/login-vue';
import { Environment } from '@attensi/api-js';

import entry from '@attensi/entry';
const accessToken = entry.getAccessToken();
const apiToken = entry.getApiToken() || 'bfb744f8bb4dbec69e8340e4b0f4d2af2098cf7c27212c490c4dac210a43d3a9';
const subdomain = entry.getSubdomain();

interface TempConfig {
    subdomain: string;
    environment: Environment;
    apiToken: string;
    accessToken: string | null;
}

let config: TempConfig;

Vue.use(AttensiLogin, {
    apiToken,
    accessToken,
    subdomain,
    checkAuth: true,
    autoLogin: false,
    environment: Environment.PRODUCTION,
    beforeHook: (options) => {
        config = options;
    },
} as AttensiLoginOptions);

export { config };
